import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DatePicker, Select } from "antd";
import moment from "moment";
import { connect } from "react-redux";
import style from "./AddPatient.module.css";
import {
    fetchDropdownList,
    fetchMedSchemes,
    fetchMedSchemesPlan,
    fetchMedSchemesPlanOptions,
    fetchMedSchemesPlanSubOptions,
    savePatientProfile,
    fetchRelatedParty,
    checkMSVDetails
} from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import history from "../../utils/history";
import { dateFormatter, isEmpty } from "../../utils/CommonUtil";
import MSVDetailsSection from "../../containers/MSVDetailsSections";
import PatientDocUpload from "./PatientDocUpload/PatientDocUpload";
import { NAME_MESSAGE, NAME_REGEX } from "../../utils/RegexConstants";
const { Option } = Select;

export class AddPatient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditMode: false,
            patientAddition: "msvPatient",
            scheme: "",
            isScreenLoaded: false,
            partyType: "individual",
            indvRelatedPartyRole: "4",
            title: "",
            firstName: "",
            surname: "",
            fullname: "",
            initials: "",
            gender: "",
            dateOfBirth: "",
            passport_number: "",
            physicalAddress: "",
            postalAddress: "",
            cellNumber: "",
            emailAddress: "",
            IdNumber: "",
            patientType: "privatePatient",
            scheme_code: "",
            membership_number: "",
            scheme_plan_code: "",
            scheme_plan_option_code: "",
            scheme_plansuboption_code: "",
            membership_passport_number: "",
            patientRelationship: "",
            member_fullname: "",
            member_surname: "",
            member_initials: "",
            communication: "sms",
            dependent_code: "",
            msvData: {},
            isLoading: false,
            isMSVLoading: false,
            successMessage: "",
            errorMessage: "",
            successMessageMSV: "",
            errorMessageMSV: "",
            uploadDocs: [],
            max_upload: localStorage.getItem("SETTING_INFO") &&
            JSON.parse(localStorage.getItem("SETTING_INFO")).max_upload,
            patientFileNumber:"",
            landlineNumber:"",
            patientHeight:"",
            patientWeight: ""
        };
    }
    componentDidMount = async () => {
        document.title = 'Edit Patient - TechToMedix';
        if (this.props.match.params.id) {
            await this.props.fetchRelatedParty(this.props.match.params.id);
            let relatedPartyData = this.props.relatedPartyData.relatedPartyData;
            this.setInitialState(relatedPartyData);
        } else {
            this.setState({patientFileNumber:Math.floor(100000 + Math.random() * 900000)})
        }

        await this.props.fetchMedSchemes("");
        if (this.state.scheme_code) {
            this.props.fetchMedSchemesPlan(this.state.scheme_code);
        }

        if (this.state.scheme_plan_code) {
            this.props.fetchMedSchemesPlanOptions(this.state.scheme_plan_code);
        }

        if (this.state.scheme_plan_option_code) {
            this.props.fetchMedSchemesPlanSubOptions(this.state.scheme_plan_option_code);
        }
        setTimeout(() => {
            this.setState({
                isScreenLoaded: true,
            });
        }, 500);
    };

    componentDidUpdate = async (prevProps, prevState) => {
        //document.title = 'TechToMed - Edit Contact';
        let relatedPartyData = "";
        if (prevProps.match.params.id !== this.props.match.params.id) {
            if (this.props.match.params.id) {
                await this.props.fetchRelatedParty(this.props.match.params.id);
                relatedPartyData = this.props.relatedPartyData.relatedPartyData;

            }
            this.setInitialState(relatedPartyData);
        }

    }


    setInitialState = (relatedPartyData) => {
        const isRelatedPartyEmpty = !Object.keys(relatedPartyData).length;
        let relatedPartyDetails = relatedPartyData.relatedPartyDetails;
        let attachment = relatedPartyData.attachment;
        
        const uploadDocs = [];
        if (!isRelatedPartyEmpty && attachment.length > 0) {
            attachment.forEach((element, index) => {
                uploadDocs.push({
                    attachment_id: element.attachment_id,
                    selectedFile: element.attachment_file_name,
                    description: element.description,
                    isNewUpload: false,
                    delete: false,
                });
            });
        }
        this.setState({
            title: isRelatedPartyEmpty ? "" : relatedPartyDetails.title,
            firstName: isRelatedPartyEmpty ? "" : relatedPartyDetails.name,
            surname: isRelatedPartyEmpty ? "" : relatedPartyDetails.surname,
            fullname: isRelatedPartyEmpty ? "" : relatedPartyDetails.fullname,
            initials: isRelatedPartyEmpty ? "" : relatedPartyDetails.initials,
            gender: isRelatedPartyEmpty ? "" : relatedPartyDetails.gender,
            dateOfBirth:
                isRelatedPartyEmpty || relatedPartyDetails.dob == null
                    ? null
                    : moment(relatedPartyDetails.dob).format("YYYY-MM-DD"),
            passport_number: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.passport_number,
            physicalAddress: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.physical_address,
            postalAddress: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.postal_address,
            patientHeight: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.height,
            patientWeight: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.weight,
            cellNumber: isRelatedPartyEmpty ? "" : relatedPartyDetails.contact_number,
            emailAddress: isRelatedPartyEmpty ? "" : relatedPartyDetails.email,
            patientType:
                (isRelatedPartyEmpty ||
                    relatedPartyDetails.isMedicalAidPatient === 0 ||
                    relatedPartyDetails.isMedicalAidPatient == null)
                    ? "privatePatient"
                    : "medicalAid",
            scheme_code: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.scheme_code,
            membership_number: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.membership_number,
            scheme_plan_code: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.scheme_plan_code,
            scheme_plan_option_code: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.scheme_plan_option_code,
            scheme_plansuboption_code: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.scheme_plansuboption_code,
            membership_passport_number: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.membership_passport_number,
            patientRelationship: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.patient_relationship_code,
            member_fullname: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.member_fullname,
            member_surname: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.member_surname,
            member_initials: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.member_initials,
            dependent_code: isRelatedPartyEmpty
                ? ""
                : relatedPartyDetails.dependant_code,
            communication: isRelatedPartyEmpty
                ? "sms"
                : (relatedPartyDetails.communication_mode ? relatedPartyDetails.communication_mode : "sms" ),
            isEditMode: isRelatedPartyEmpty ? false : true,
            uploadDocs: [...uploadDocs],
            msvData: {},
            patientFileNumber:isRelatedPartyEmpty?Math.floor(100000 + Math.random() * 900000):relatedPartyDetails.file_number,
            landlineNumber:isRelatedPartyEmpty?"":relatedPartyDetails.landline_number
        }, () => {
            // console.log("state", this.state)
        })
    }

    saveMSVData = () => {
        let patientData = this.state.msvData;

        if (patientData) {
            this.setState({
                member_fullname: patientData.member_fullname ? patientData.member_fullname : this.state.member_fullname,
                member_surname: patientData.member_surname ? patientData.member_surname : this.state.member_surname,
                passport_number: patientData.passport_number ? patientData.passport_number : this.state.passport_number,
                membership_number: patientData.membership_number ? patientData.membership_number : this.state.membership_number,
                fullname: patientData.patient_name ? patientData.patient_name : this.state.fullname,
                surname: patientData.patient_surname ? patientData.patient_surname : this.state.surname,
                initials: patientData.patient_initials ? patientData.patient_initials : this.state.initials,
                physicalAddress: patientData.address1 ? patientData.address1 : this.state.physicalAddress,
                dateOfBirth: patientData.dob ? moment(patientData.dob).format("YYYY-MM-DD") : this.state.dateOfBirth,
                gender: patientData.gender ? (patientData.gender === "F" ? "Female" : "Male") : this.state.gender,
                dependent_code: patientData.patient_dependant_code ? patientData.patient_dependant_code : this.state.dependent_code,
                errorMessage: ""
            })
        }

    }

    disabledDate = (current) => {
        // Can not select days after today and today
        return current && current > moment().startOf("day");
    };
    goBack = () => {
        history.goBack();
    };

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState({
            [name]: value
        })

        if(name === "firstName"){
           // let fullname = value  + (this.state.surname ? (" " + this.state.surname) : "");
           let fullname = value;
            this.setState({
                fullname: fullname
            })
        }
        if(name === "surname"){
            // let fullname = (this.state.firstName ? (this.state.firstName + " ") : "") + value;
            // this.setState({
            //     fullname: fullname
            // })
             this.generateFileNumber()
        }

        if (name === "patientRelationship") {
            if (value === "01") {
                this.setState({
                    member_fullname: this.state.fullname,
                    member_surname: this.state.surname,
                    member_initials: this.state.initials,
                    membership_passport_number: this.state.passport_number,
                })

            } else {
                // this.setState({
                //     member_fullname: "",
                //     member_surname: "",
                //     member_initials: "",
                //     membership_passport_number: "",
                //     dependent_code: "",
                // })
            }
        }
    }



    handleAutoCompSelectChange = (value, name) => {
        //console.log("value", value);
        if (name === "scheme_code") {
            // console.log("med scheme selected");

            if (this.state.scheme_plan_code) {
                this.setState({
                    scheme_plan_code: "",
                });
            }
            if (this.state.scheme_plan_option_code) {
                this.setState({
                    scheme_plan_option_code: "",
                });
            }
            if (this.state.scheme_plansuboption_code) {
                this.setState({
                    scheme_plansuboption_code: "",
                });
            }
            if (value) {
                this.props.fetchMedSchemesPlan(value);
            }
        }
        if (name === "scheme_plan_code") {
            // console.log("med scheme selected");

            if (this.state.scheme_plan_option_code) {
                this.setState({
                    scheme_plan_option_code: "",
                });
            }
            if (this.state.scheme_plansuboption_code) {
                this.setState({
                    scheme_plansuboption_code: "",
                });
            }
            if (value) {
                this.props.fetchMedSchemesPlanOptions(value);
            }
        }
        if (name === "scheme_plan_option_code") {
            // console.log("med scheme selected");
            if (this.state.scheme_plansuboption_code) {
                this.setState({
                    scheme_plansuboption_code: "",
                });
            }
            if (value) {
                this.props.fetchMedSchemesPlanSubOptions(value);
            }
        }
        this.setState({
            [name]: value
        })
    }

    getUploadDocs = (docs) => {
        this.setState({
            uploadDocs: [...docs]
        })
    }

    checkMSVAgain = () => {
        this.setState({
            msvData: {}
        })
    }

    onaddViaMSV = async () => {
        this.setState({
            isMSVLoading: true
        })
        const payload = {
            surname: this.state.surname,
            dob: dateFormatter(this.state.dateOfBirth),
            scheme_code: this.state.scheme_code,
            membership_number: this.state.membership_number,
            scheme_plan_code: this.state.scheme_plan_code,
            scheme_plan_option_code: this.state.scheme_plan_option_code,
            scheme_plan_suboption_code: this.state.scheme_plansuboption_code,
            fullname: this.state.fullname,
        }

        if (this.state.isEditMode) {
            payload.patient_id = this.props.match.params.id;
        }

        await this.props.checkMSVDetails(payload);

        if (!this.props.checkMSVDetailsData.loading) {
            if (!this.props.checkMSVDetailsData.error) {
                let data = this.props.checkMSVDetailsData.checkMSVDetails;
                this.setState({
                    successMessageMSV: "",
                    msvData: !isEmpty(data) ? data : {},
                    msvHistoryId: !isEmpty(data) &&
                        data.member_status_validation_history_id ? data.member_status_validation_history_id : "",
                    isMSVLoading: false,
                    errorMessageMSV: ""
                })

                setTimeout(() => {
                    this.setState({
                        successMessageMSV: "",
                    })

                }, 2000);
            } else {
                this.setState({
                    errorMessageMSV: this.props.checkMSVDetailsData.error,
                    successMessageMSV: "",
                    isMSVLoading: false
                })

                setTimeout(() => {
                    this.setState({
                        errorMessageMSV: ""
                    })
                }, 15000);

            }
        }
    }

    generateFileNumber = async () => {
        const number=Math.floor(100000 + Math.random() * 900000);
        this.setState({patientFileNumber:this.state.surname.substring(0,3)+number})
    }

    onSubmit = async () => {
        //console.log("form submitted")

        this.setState({
            isLoading: true
        })

        const formData = new FormData();
        const payload = {
            relatedPartyDetails: {
                height:this.state.patientHeight,
                weight: this.state.patientWeight,
                title: this.state.title,
                name: this.state.firstName,
                surname: this.state.surname,
                gender: this.state.gender,
                dob: dateFormatter(this.state.dateOfBirth),
                passport_number: this.state.passport_number,
                physical_address: this.state.physicalAddress,
                postal_address: this.state.postalAddress,
                contact_number: this.state.cellNumber,
                email: this.state.emailAddress? this.state.emailAddress: "",
                communication_mode: this.state.communication,
                related_party_type: "individual",
                lk_related_party_role_id: 4,
                isSystemUser: 0,
                scheme_code: this.state.scheme_code,
                membership_number: this.state.membership_number,
                scheme_plan_code: this.state.scheme_plan_code,
                scheme_plan_option_code: this.state.scheme_plan_option_code,
                scheme_plansuboption_code: this.state.scheme_plansuboption_code,
                membership_passport_number: this.state.membership_passport_number,
                patient_relationship_code: this.state.patientRelationship,
                member_fullname: this.state.member_fullname,
                member_surname: this.state.member_surname,
                // height: this.state.height ? Number(this.state.height) : "",
                // weight: this.state.weight ? Number(this.state.weight) : "",
                initials: this.state.initials,
                fullname: this.state.fullname,
                dependant_code: this.state.dependent_code,
                member_initials: this.state.member_initials,
                isMedicalAidPatient: this.state.patientType === "medicalAid" ? 1 : 0,
                file_number:this.state.patientFileNumber,
                landline_number:this.state.landlineNumber

            }
        }
        console.log("payload", payload)
        if (this.state.msvHistoryId) {
            payload.member_status_validation_history_id = this.state.msvHistoryId
            formData.append("member_status_validation_history_id", payload.member_status_validation_history_id);
        }

        if (this.state.isEditMode) {
            payload.relatedPartyDetails.related_party_id = this.props.match.params.id;
        }

        
        const attachmentData = [];
        if(this.state.uploadDocs.length > 0){
            this.state.uploadDocs.forEach((element, index) => {
              if (element.isNewUpload) {
                formData.append("attachment", element.selectedFile);
                formData.append("description", element.description);
              } else {
                attachmentData.push({
                  attachment_id: element.attachment_id,
                  description: element.description,
                  delete: element.delete,
                });
              }
            });
        }
        formData.append("attachmentData", JSON.stringify(attachmentData));
        formData.append(
          "relatedPartyDetails",
          JSON.stringify({ ...payload.relatedPartyDetails })
        );
        await this.props.savePatientProfile(formData);

        if (!this.props.savePatientData.loading) {
            if (!this.props.savePatientData.errorMessage) {
                this.setState({
                    successMessage: this.props.savePatientData.successMessage,
                    isLoading: false,
                    errorMessage: ""
                })

                setTimeout(() => {
                    this.setState({
                        successMessage: "",
                    })

                    this.props.history.push({
                        pathname: "/app/patients"
                    });
                }, 2000);
            } else {
                this.setState({
                    errorMessage: this.props.savePatientData.errorMessage,
                    successMessage: "",
                    isLoading: false
                })

                setTimeout(() => {
                    this.setState({
                        errorMessage: ""
                    })
                }, 2000);

            }
        }

    }



    render() {
        // getting dropdown list options from redux persist
        const dropdownData = this.props.dropdownListData.dropdownList;
        const schemesDropDownListData = this.props.schemesData.schemes;
        const schemesPlanDropDownListData = this.props.schemesPlanData.schemesPlan;
        const schemesPlanOptionsDropDownListData = this.props.schemesPlanOptionsData.schemesPlanOptions;
        const schemesPlanSubOptionsDropDownListData = this.props.schemesPlanSubOptionsData.schemesPlanSubOptions;
        const isDropdownEmpty = !Object.keys(dropdownData).length;

        // getting title from dropdown json
        const titleOptions =
            dropdownData &&
            !isDropdownEmpty &&
            dropdownData.prefix.map((element, index) => (
                <option key={index} value={element.prefix_id}>
                    {element.prefix_name}
                </option>
            ));


        // const mediaclAidSchemeOptions = schemesDropDownListData &&
        //     schemesDropDownListData.map((element, index) => (
        //         <option key={index} value={element.code}>
        //             {element.name} ({element.code})
        //         </option>
        //     ));


        const mediaclAidSchemePlanOptions = schemesPlanDropDownListData &&
            schemesPlanDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));


        const mediaclAidSchemePlanOptionsOptions = schemesPlanOptionsDropDownListData &&
            schemesPlanOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));
        const mediaclAidSchemePlanSubOptionsOptions = schemesPlanSubOptionsDropDownListData &&
            schemesPlanSubOptionsDropDownListData.map((element, index) => (
                <option key={index} value={element.code}>
                    {element.name} ({element.code})
                </option>
            ));

        const patientRelationshipOptions = dropdownData &&
            !isDropdownEmpty &&
            dropdownData.lk_patient_relation.map((opt, index) => (
                <option key={index} value={opt.code}>
                    {opt.patient_relation}
                </option>
            ));

        if (!this.state.isScreenLoaded) {
            return (
                <div className="dashboard-loader">
                    <img src={ttmLoader} alt="loader" className="loader-image" />
                </div>
            );
        }

        return (
            <div className={style.individualInfoMainWrapper}>
                <div className={style.headingWrapper}>
                    <div className="row">
                        <div className="col-lg-12 intro-text">
                            <h2>Patient Creation - Individual Info</h2>
                            <p>
                            Capture the Patient's details as requested on the form below. 
                            Ensure that the Patient's email address is captured correctly as it will be used to send notifications 
                            where applicable.
              </p>
                        </div>
                    </div>
                </div>

                <div
                    className={`form-controls-wrapper ${style.individualInfoFormWrapper}`}
                >

                    <div className="row form-group">
                        <div className="col-md-12 d-flex flex-wrap">
                            <label className="mr-3">Patient Type:</label>
                            <div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        className="custom-control-input"
                                        id="privatePatient"
                                        name="patientType"
                                        checked={
                                            this.state.patientType === "privatePatient"
                                        }
                                        onChange={this.handleChange}
                                        value="privatePatient"
                                    />
                                    <label
                                        className={`custom-control-label ${style.patientType}`}
                                        htmlFor="privatePatient"
                                    >
                                        Private Patient
                                            </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        className="custom-control-input"
                                        id="medicalAid"
                                        name="patientType"
                                        checked={this.state.patientType === "medicalAid"}
                                        onChange={this.handleChange}
                                        value="medicalAid"
                                    />
                                    <label
                                        className={`custom-control-label ${style.patientType}`}
                                        htmlFor="medicalAid"
                                    >
                                        Medical Aid Patient
                                             </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.patientType === "medicalAid" && (this.state.msvData && !this.state.msvData.result_status) && (
                        <React.Fragment>
                            <div className="row form-group">
                                <div className="col-md-12">
                                    <label className="mr-3">Choose method to enter the Patient Details:</label>
                                    <div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                className="custom-control-input"
                                                id="msvPatient"
                                                name="patientAddition"
                                                checked={this.state.patientAddition === "msvPatient"}
                                                onChange={this.handleChange}
                                                value="msvPatient"
                                            />
                                            <label
                                                className={`custom-control-label ${style.patientType}`}
                                                htmlFor="msvPatient"
                                            >
                                                Via MSV
                                             </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input
                                                type="radio"
                                                className="custom-control-input"
                                                id="manualPatient"
                                                name="patientAddition"
                                                checked={
                                                    this.state.patientAddition === "manualPatient"
                                                }
                                                onChange={this.handleChange}
                                                value="manualPatient"
                                            />
                                            <label
                                                className={`custom-control-label ${style.patientType}`}
                                                htmlFor="manualPatient"
                                            >
                                                Manually
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            {this.state.patientAddition === "msvPatient" && (
                                <Formik
                                    initialValues={this.state}
                                    enableReinitialize={true}
                                    validationSchema={Yup.object().shape({
                                        firstName: Yup.string().trim()
                                            .required("First Name is required")
                                            .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
                                        surname: Yup.string().trim()
                                            .required("Surname is required")
                                            .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
                                        scheme_code: Yup.string().when("patientType", {
                                            is: (value) => value === "medicalAid",
                                            then: Yup.string()
                                                .required("Medical Aid Scheme is required"),
                                            otherwise: Yup.string().nullable(),
                                        }).nullable(),
                                        scheme_plan_code: Yup.string().when("patientType", {
                                            is: (value) => value === "medicalAid",
                                            then: Yup.string()
                                                .required("Medical Aid Plan is required"),
                                            otherwise: Yup.string().nullable(),
                                        }).nullable(),
                                        dateOfBirth: Yup.string().required("Date Of Birth is required").nullable(),
                                        scheme_plan_option_code: Yup.string().when("patientType", {
                                          is: (value) => value === "medicalAid",
                                          then: Yup.string()
                                            .required("Medical Aid Plan Option is required"),
                                          otherwise: Yup.string().nullable(),
                                        }),
                                        scheme_plansuboption_code: Yup.string().when("patientType", {
                                          is: (value) => value === "medicalAid",
                                          then: Yup.string()
                                            .required("Medical Aid Plan Sub Option is required"),
                                          otherwise: Yup.string().nullable(),
                                        }),
                                        membership_number: Yup.string().when("patientType", {
                                            is: (value) => value === "medicalAid",
                                            then: Yup.string()
                                                .required("Membership Number is required")
                                                .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                                            otherwise: Yup.string().nullable(),
                                        }).nullable(),
                                    })}
                                    onSubmit={this.onaddViaMSV}
                                >
                                    {({ errors, status, touched, setFieldValue, setFieldTouched }) => (
                                        <Form>
                                            <div>
                                                <div className="form-box-shadow mb-4">
                                                    <div className="row">
                                                        <div className="col-lg-12">
                                                            <label>Perform an MSV check and fetch the patient information by entering the below details: </label>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                            <div className="form-group">
                                                                <label htmlFor="firstName">
                                                                    Patient First Names
                                                                        <span className="mandatory">*</span>
                                                                </label>

                                                                <Field
                                                                    name="firstName"
                                                                    type="text"
                                                                    maxLength="30"
                                                                    placeholder="First Name"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.firstName && touched.firstName
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    onChange={this.handleChange}
                                                                />
                                                                <ErrorMessage
                                                                    name="firstName"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                            <div className="form-group">
                                                                <label htmlFor="surname">Patient Surname
                                                                        <span className="mandatory">*</span>
                                                                </label>

                                                                <Field
                                                                    name="surname"
                                                                    maxLength="30"
                                                                    placeholder="Surname"
                                                                    type="text"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.surname && touched.surname
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    onChange={this.handleChange}
                                                                />
                                                                <ErrorMessage
                                                                    name="surname"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                            <label htmlFor="dateOfBirth">
                                                                Date Of Birth <span className="mandatory">*</span>
                                                            </label>
                                                            <DatePicker
                                                                disabledDate={this.disabledDate}
                                                                name="dateOfBirth"
                                                                onChange={(date, dateString) => {
                                                                    this.handleAutoCompSelectChange(dateString, "dateOfBirth")
                                                                }}
                                                                placeholder="Date of birth"
                                                                //selected={moment(this.state.dateOfBirth)}
                                                                className={
                                                                    "form-control" +
                                                                    (errors.dateOfBirth && touched.dateOfBirth
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                format="YYYY-MM-DD"
                                                                value={
                                                                    this.state.dateOfBirth
                                                                        ? moment(this.state.dateOfBirth)
                                                                        : null
                                                                }
                                                                onBlur={() => {
                                                                    setFieldTouched("dateOfBirth", true)
                                                                }}
                                                            />
                                                            <ErrorMessage
                                                                name="dateOfBirth"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                            <label htmlFor="scheme_code">Medical Aid Scheme{" "}<span className="mandatory">*</span></label>
                                                            <Select
                                                                showSearch={true}
                                                                showArrow={true}
                                                                allowClear={true}
                                                                name="scheme_code"
                                                                placeholder="Search and select scheme"
                                                                optionFilterProp="children"
                                                                onBlur={() => {
                                                                    setFieldTouched("scheme_code", true)
                                                                }}
                                                                onChange={(value) => {
                                                                    this.handleAutoCompSelectChange(value, "scheme_code");
                                                                }}
                                                                filterOption={(input, option) =>
                                                                    option.children.toString()
                                                                        .toLowerCase()
                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                className={
                                                                    (errors.scheme_code &&
                                                                        touched.scheme_code
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                value={this.state.scheme_code || undefined}
                                                            >
                                                                {schemesDropDownListData &&
                                                                    schemesDropDownListData.map((element, index) => (
                                                                        <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                            {element.name} ({element.code})
                                                                        </Option>
                                                                    ))}
                                                            </Select>
                                                            <ErrorMessage
                                                                name="scheme_code"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>
                                                        <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                            <label htmlFor="scheme_plan_code">Medical Aid Plan{" "}<span className="mandatory">*</span></label>
                                                            <Select
                                                                showSearch={true}
                                                                showArrow={true}
                                                                allowClear={true}
                                                                name="scheme_plan_code"
                                                                disabled={!this.state.scheme_code}
                                                                placeholder="Search and select scheme plan"
                                                                optionFilterProp="children"
                                                                onBlur={() => {
                                                                    setFieldTouched("scheme_plan_code", true)
                                                                }}
                                                                onChange={(value) => {
                                                                    this.handleAutoCompSelectChange(value, "scheme_plan_code");
                                                                }}
                                                                filterOption={(input, option) =>
                                                                    option.children.toString()
                                                                        .toLowerCase()
                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                className={
                                                                    (errors.scheme_plan_code &&
                                                                        touched.scheme_plan_code
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                value={this.state.scheme_plan_code || undefined}
                                                            >
                                                                {schemesPlanDropDownListData &&
                                                                    schemesPlanDropDownListData.map((element, index) => (
                                                                        <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                            {element.name} ({element.code})
                                                                        </Option>
                                                                    ))}
                                                            </Select>
                                                            <ErrorMessage
                                                                name="scheme_plan_code"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>
                                                        {mediaclAidSchemePlanOptions &&
                                                            mediaclAidSchemePlanOptions.length > 0 &&
                                                            mediaclAidSchemePlanOptionsOptions &&
                                                            mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                            (<div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                                <label htmlFor="scheme_plan_option_code">Medical Aid Plan Options{" "}
                                                                    <span className="mandatory">*</span>
                                                                </label>
                                                                <Select
                                                                    showSearch={true}
                                                                    showArrow={true}
                                                                    allowClear={true}
                                                                    disabled={!this.state.scheme_plan_code}
                                                                    name="scheme_plan_option_code"
                                                                    placeholder="Search and select scheme plan option"
                                                                    optionFilterProp="children"
                                                                    onBlur={() => {
                                                                        setFieldTouched("scheme_plan_option_code", true)
                                                                    }}
                                                                    onChange={(value) => {
                                                                        this.handleAutoCompSelectChange(value, "scheme_plan_option_code");
                                                                    }}
                                                                    filterOption={(input, option) =>
                                                                        option.children.toString()
                                                                            .toLowerCase()
                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                    }
                                                                    className={
                                                                        (errors.scheme_plan_option_code &&
                                                                            touched.scheme_plan_option_code
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    value={this.state.scheme_plan_option_code || undefined}
                                                                >
                                                                    {schemesPlanOptionsDropDownListData &&
                                                                        schemesPlanOptionsDropDownListData.map((element, index) => (
                                                                            <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                                {element.name} ({element.code})
                                                                            </Option>
                                                                        ))}
                                                                </Select>
                                                                <ErrorMessage
                                                                    name="scheme_plan_option_code"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </div>)}

                                                        {mediaclAidSchemePlanOptions &&
                                                            mediaclAidSchemePlanOptions.length > 0 &&
                                                            mediaclAidSchemePlanOptionsOptions &&
                                                            mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                            mediaclAidSchemePlanSubOptionsOptions &&
                                                            mediaclAidSchemePlanSubOptionsOptions.length > 0 && (
                                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                                    <label htmlFor="scheme_plansuboption_code">Medical Aid Plan Sub Options{" "}
                                                                        <span className="mandatory">*</span>
                                                                    </label>
                                                                    <Select
                                                                        showSearch={true}
                                                                        showArrow={true}
                                                                        allowClear={true}
                                                                        disabled={!this.state.scheme_plan_option_code}
                                                                        name="scheme_plansuboption_code"
                                                                        placeholder="Search and select scheme plan suboption"
                                                                        optionFilterProp="children"
                                                                        onBlur={() => {
                                                                            setFieldTouched("scheme_plansuboption_code", true)
                                                                        }}
                                                                        onChange={(value) => {
                                                                            this.handleAutoCompSelectChange(value, "scheme_plansuboption_code");
                                                                            //this.handleChange(e);
                                                                        }}
                                                                        filterOption={(input, option) =>
                                                                            option.children.toString()
                                                                                .toLowerCase()
                                                                                .indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        className={
                                                                            (errors.scheme_plansuboption_code &&
                                                                                touched.scheme_plansuboption_code
                                                                                ? " is-invalid"
                                                                                : "")
                                                                        }
                                                                        value={this.state.scheme_plansuboption_code || undefined}
                                                                    >
                                                                        {schemesPlanSubOptionsDropDownListData &&
                                                                            schemesPlanSubOptionsDropDownListData.map((element, index) => (
                                                                                <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                                    {element.name} ({element.code})
                                                                                </Option>
                                                                            ))}
                                                                    </Select>
                                                                    <ErrorMessage
                                                                        name="scheme_plansuboption_code"
                                                                        component="div"
                                                                        className="invalid-feedback"
                                                                    />
                                                                </div>)}
                                                        <div className="col-md-6 col-lg-4 col-xl-3">
                                                            <div className="form-group">
                                                                <label htmlFor="membership_number">Membership Number
                                                                        <span className="mandatory">*</span>
                                                                </label>

                                                                <Field
                                                                    name="membership_number"
                                                                    type="text"
                                                                    maxLength="20"
                                                                    placeholder="Membership Number"
                                                                    className={
                                                                        "form-control" +
                                                                        (errors.membership_number && touched.membership_number
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }
                                                                    onChange={this.handleChange}
                                                                />
                                                                <ErrorMessage
                                                                    name="membership_number"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div >
                                                        <button
                                                            type="submit"
                                                            className="btn form-primary-btn"
                                                        >
                                                            {this.state.isEditMode ? "UPDATE" : "ADD"} VIA MSV
                                                    </button>
                                                    </div>
                                                    {this.state.isMSVLoading && (
                                                        <div className={`error ${style.loadingWrapper}`}>
                                                            <img src={ttmLoader} alt="loader" className={style.loading} />
                                                        </div>
                                                    )}
                                                    {!this.state.isMSVLoading &&
                                                        this.state.successMessageMSV && (
                                                            <div className="textCenter">
                                                                <p className={`success-message`}>{this.state.successMessageMSV}</p>
                                                            </div>)}
                                                    {!this.state.isMSVLoading &&
                                                        this.state.errorMessageMSV && (
                                                            <div className="textCenter">
                                                                <p className={`error-message`}>{this.state.errorMessageMSV}</p>
                                                            </div>
                                                        )}


                                                </div>

                                            </div>
                                        </Form>)}

                                </Formik>

                            )}

                        </React.Fragment>)}

                    {this.state.msvData &&
                        this.state.msvData.result_status === "Invalid" && (
                            <div className="mt-3">

                                <button
                                    type="button"
                                    className="btn form-primary-btn"
                                    onClick={this.checkMSVAgain}
                                >
                                    Check MSV again
                                                    </button>
                            </div>
                        )}

                    {this.state.msvData &&
                        this.state.msvData.result_status && (
                            <div className="mt-3">
                                <MSVDetailsSection
                                    data={this.state.msvData}
                                    saveMSVData={this.saveMSVData}
                                    claimProcess={this.state.msvData.result_status === "Valid"}
                                />

                            </div>
                        )}


                    <Formik
                        initialValues={this.state}
                        enableReinitialize={true}
                        validationSchema={Yup.object().shape({
                            emailAddress: Yup.string().trim()
                                .email("Email is invalid").nullable(),
                               // .required("Email is required"),
                            title: Yup.string().required("Title is required").nullable(),
                            firstName: Yup.string().trim()
                                .required("First Name is required")
                                .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
                            surname: Yup.string().trim()
                                .required("Surname is required")
                                .matches(NAME_REGEX, NAME_MESSAGE).nullable(),
                            // fullname: Yup.string().trim()
                            //     .required("Full Name is required")
                            //     .matches(/^[a-zA-Z ]*$/, "Enter alphabets only"),
                            initials: Yup.string().trim()
                                .required("Initials are required").nullable(),
                            gender: Yup.string().required("Gender is required").nullable(),
                            dateOfBirth: Yup.string().required("Date Of Birth is required").nullable(),
                            cellNumber: Yup.string().trim()
                                .required("Cell Phone Number is required")
                                .matches(/^\d+$/, "Only numbers allowed")
                                .min(10, "Must be exactly 10 digits").nullable(),
                            landlineNumber: Yup.string().trim()
                                .matches(/^\d+$/, "Only numbers allowed")
                                .nullable(),
                            scheme_code: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .required("Medical Aid Scheme is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            membership_number: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .trim()
                                    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed")
                                    .required("Membership Number is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            scheme_plan_code: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .required("Medical Aid Plan is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            passport_number: Yup.string()
                                .required("ID/Passport is required")
                                .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                            // height: Yup.string()
                            //     .required("Height is required")
                            //     .matches(/^[0-9]*$/, "Enter numbers only"),
                            // weight: Yup.string()
                            //     .required("Weight is required")
                            //     .matches(/^[0-9]*$/, "Enter numbers only"),
                            // scheme_plan_option_code: Yup.string().when("patientType", {
                            //   is: (value) => value === "medicalAid",
                            //   then: Yup.string()
                            //     .required("Medical Aid Plan Option is required"),
                            //   otherwise: Yup.string().nullable(),
                            // }),
                            // scheme_plansuboption_code: Yup.string().when("patientType", {
                            //   is: (value) => value === "medicalAid",
                            //   then: Yup.string()
                            //     .required("Medical Aid Plan Sub Option is required"),
                            //   otherwise: Yup.string().nullable(),
                            // }),
                            member_fullname: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .trim()
                                    .matches(NAME_REGEX, NAME_MESSAGE).nullable()
                                    .required("Full Name is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            member_surname: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string().trim()
                                    .matches(NAME_REGEX, NAME_MESSAGE).nullable()
                                    .required("Surname is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            member_initials: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .required("Member Initials are required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            membership_passport_number: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .required("Medical ID/Passport is required")
                                    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphanumeric values allowed"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            patientRelationship: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string()
                                    .required("Patient Relationship is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            dependent_code: Yup.string().when("patientType", {
                                is: (value) => value === "medicalAid",
                                then: Yup.string().trim()
                                    .matches(/^[0-9]*$/, "Enter numbers only")
                                    .required("Dependent code is required"),
                                otherwise: Yup.string().nullable(),
                            }).nullable(),
                            patientFileNumber: Yup.string().trim()
                                            .required("Patient File Number is required")
                        })}
                        onSubmit={this.onSubmit}
                    >
                        {({ errors, status, touched, setFieldValue, setFieldTouched }) => (
                            <Form>
                                <div>
                                    <div className="form-box-shadow mt-3 mb-4">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <h5>Patient Details</h5>
                                            </div>
                                        </div>
                                        <div className="row form-group">
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="title">
                                                    Title <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="title"
                                                    as="select"
                                                    placeholder="Select Title"
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.title && touched.title
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                >
                                                    <option value="">Select Title</option>
                                                    {titleOptions}
                                                </Field>
                                                <ErrorMessage
                                                    name="title"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="firstName">
                                                    First Names <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="firstName"
                                                    placeholder="First Names"
                                                    maxLength="20"
                                                    value={this.state.firstName}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.firstName && touched.firstName
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="firstName"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="surname">
                                                    Surname <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="surname"
                                                    placeholder="Surname"
                                                    maxLength="20"
                                                    value={this.state.surname}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.surname && touched.surname
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="surname"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                            {/* <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="fullname">
                                                    Full Name <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="fullname"
                                                    placeholder="Full Name"
                                                    maxLength="20"
                                                    value={this.state.fullname}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.fullname && touched.fullname
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="fullname"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div> */}
                                            <div className="col-md-6 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label htmlFor="initials">Initials
                                                    <span className="mandatory">*</span>
                                                    </label>

                                                    <Field
                                                        type="text"
                                                        name="initials"
                                                        placeholder="Initials"
                                                        maxLength="5"
                                                        className={
                                                            "form-control" +
                                                            (errors.initials && touched.initials
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleChange}

                                                    >
                                                    </Field>
                                                    <ErrorMessage
                                                        name="initials"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="dateOfBirth">
                                                    Date Of Birth <span className="mandatory">*</span>
                                                </label>
                                                <DatePicker
                                                    disabledDate={this.disabledDate}
                                                    name="dateOfBirth"
                                                    onChange={(date, dateString) => {
                                                        this.handleAutoCompSelectChange(dateString, "dateOfBirth")
                                                    }}
                                                    placeholder="Date of birth"
                                                    //selected={moment(this.state.dateOfBirth)}
                                                    className={
                                                        "form-control" +
                                                        (errors.dateOfBirth && touched.dateOfBirth
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                    format="YYYY-MM-DD"
                                                    value={
                                                        this.state.dateOfBirth
                                                            ? moment(this.state.dateOfBirth)
                                                            : ""
                                                    }
                                                    onBlur={() => {
                                                        setFieldTouched("dateOfBirth", true)
                                                    }}
                                                />
                                                <ErrorMessage
                                                    name="dateOfBirth"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="gender">
                                                    Gender <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="gender"
                                                    as="select"
                                                    placeholder="Gender"
                                                    value={this.state.gender}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.gender && touched.gender
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                >
                                                    <option value="">Select gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </Field>
                                                <ErrorMessage
                                                    name="gender"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="passport_number">ID/Passport Number
                                                <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="passport_number"
                                                    placeholder="Passport Number"
                                                    maxLength="20"
                                                    value={this.state.passport_number}
                                                    onChange={this.handleChange}
                                                    disabled={this.state.isEditMode ? true : false}
                                                    className={
                                                        "form-control" +
                                                        (errors.passport_number && touched.passport_number
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="passport_number"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="cellNumber">
                                                    Contact Number <span className="mandatory">*</span>
                                                </label>
                                                <Field
                                                    name="cellNumber"
                                                    placeholder="Contact Number"
                                                    maxLength="15"
                                                    value={this.state.cellNumber}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.cellNumber && touched.cellNumber
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="cellNumber"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="landlineNumber">
                                                    Landline Number
                                                </label>
                                                <Field
                                                    name="landlineNumber"
                                                    placeholder="Landline Number"
                                                    value={this.state.landlineNumber}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.landlineNumber && touched.landlineNumber
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="landlineNumber"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>

                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="emailAddress">
                                                    Email Address
                                                </label>
                                                <Field
                                                    name="emailAddress"
                                                    placeholder="Email Address"
                                                    value={this.state.emailAddress}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.emailAddress &&
                                                            touched.emailAddress
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="emailAddress"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="physicalAddress">Physical Address</label>
                                                <Field
                                                    name="physicalAddress"
                                                    placeholder="Physical Address"
                                                    maxLength="100"
                                                    value={this.state.physicalAddress}
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="postalAddress">Postal Address (Optional)</label>
                                                <Field
                                                    name="postalAddress"
                                                    placeholder="Postal Address"
                                                    maxLength="100"
                                                    value={this.state.postalAddress}
                                                    onChange={this.handleChange}
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="postalAddress">Patient File Number<span className="mandatory">*</span></label>
                                                <Field
                                                    name="patientFileNumber"
                                                    placeholder="Patient File Number"
                                                    maxLength="35"
                                                    value={this.state.patientFileNumber}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" +
                                                        (errors.patientFileNumber && touched.patientFileNumber
                                                            ? " is-invalid"
                                                            : "")
                                                    }
                                                />
                                                <ErrorMessage
                                                    name="patientFileNumber"
                                                    component="div"
                                                    className="invalid-feedback"
                                                />
                                            </div>
                                             <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="postalAddress">Patient Height (in cm)</label>
                                                <Field
                                                    name="patientHeight"
                                                    placeholder="Patient Height"
                                                    maxLength="3"
                                                    value={this.state.patientHeight}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control" 
                                                        
                                                    }
                                                />
                                              
                                            </div>
                                              <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                <label htmlFor="postalAddress">Patient Weight (in gram)</label>
                                                <Field
                                                    name="patientWeight"
                                                    placeholder="Patient Weight"
                                                    maxLength="6"
                                                    value={this.state.patientWeight}
                                                    onChange={this.handleChange}
                                                    className={
                                                        "form-control"
                                                    }
                                                />
                                            </div>
                                            {this.state.patientType === "medicalAid" && (
                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                    <div className="form-group">
                                                        <label htmlFor="dependent_code">Dependent Code
                                                <span className="mandatory">*</span>
                                                        </label>

                                                        <Field
                                                            name="dependent_code"
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="Dependent Code"
                                                            className={
                                                                "form-control" +
                                                                (errors.dependent_code && touched.dependent_code
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }
                                                            onChange={this.handleChange}
                                                        />
                                                        <ErrorMessage
                                                            name="dependent_code"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {/* <div className="col-md-6 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label htmlFor="height">Height (in cm)
                                                    <span className="mandatory">*</span></label>
                                                    <Field
                                                        type="text"
                                                        name="height"
                                                        maxLength="3"
                                                        placeholder="Height (Rounded off manner)"
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.height && touched.height
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    >
                                                    </Field>
                                                    <ErrorMessage
                                                        name="height"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                            </div> */}

                                            {/* <div className="col-md-6 col-lg-4 col-xl-3">
                                                <div className="form-group">
                                                    <label htmlFor="weight">Weight (in gms)
                                                    <span className="mandatory">*</span></label>

                                                    <Field
                                                        name="weight"
                                                        type="text"
                                                        maxLength="6"
                                                        placeholder="Weight (Rounded off manner)"
                                                        className={
                                                            "form-control" +
                                                            (errors.weight && touched.weight
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        onChange={this.handleChange}
                                                    />
                                                    <ErrorMessage
                                                        name="weight"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                            </div> */}
                                        </div>



                                        {/* Hide and show div based on patient type and medical aid choice */}
                                        {this.state.patientType === "medicalAid" && (
                                            <div className="row form-group" id="medical-aid-wrapper">
                                                <div className="col-lg-12">
                                                    <h5>Member Details</h5>
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="patientRelationship">Relationship To Main Member{" "}<span className="mandatory">*</span></label>
                                                    <Field
                                                        as="select"
                                                        name="patientRelationship"
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.patientRelationship &&
                                                                touched.patientRelationship
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    >
                                                        <option value="">Select Relationship</option>
                                                        {patientRelationshipOptions}
                                                    </Field>
                                                    <ErrorMessage
                                                        name="patientRelationship"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>

                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="member_fullname">
                                                        Member Full Name{" "}<span className="mandatory">*</span></label>
                                                    <Field
                                                        name="member_fullname"
                                                        maxLength="20"
                                                        placeholder="Member Full Name"
                                                        value={this.state.member_fullname}
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.member_fullname &&
                                                                touched.member_fullname
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    />
                                                    <ErrorMessage
                                                        name="member_fullname"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="member_surname">
                                                        Member Surname{" "}<span className="mandatory">*</span></label>
                                                    <Field
                                                        name="member_surname"
                                                        maxLength="20"
                                                        placeholder="Member Surname"
                                                        value={this.state.member_surname}
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.member_surname &&
                                                                touched.member_surname
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    />
                                                    <ErrorMessage
                                                        name="member_surname"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3">
                                                    <div className="form-group">
                                                        <label htmlFor="member_initials">Member Initials
                                                                        <span className="mandatory">*</span>
                                                        </label>

                                                        <Field
                                                            type="text"
                                                            name="member_initials"
                                                            placeholder="Member Initials"
                                                            maxLength="5"
                                                            className={
                                                                "form-control" +
                                                                (errors.member_initials && touched.member_initials
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }
                                                            onChange={this.handleChange}

                                                        >
                                                        </Field>
                                                        <ErrorMessage
                                                            name="member_initials"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="membership_number">
                                                        Membership Number{" "}(Primary)<span className="mandatory">*</span></label>
                                                    <Field
                                                        name="membership_number"
                                                        maxLength="20"
                                                        placeholder="Membership Number"
                                                        value={this.state.membership_number}
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.membership_number &&
                                                                touched.membership_number
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    />
                                                    <ErrorMessage
                                                        name="membership_number"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="scheme_code">Medical Aid Scheme{" "}<span className="mandatory">*</span></label>
                                                    <Select
                                                        showSearch={true}
                                                        showArrow={true}
                                                        allowClear={true}
                                                        name="scheme_code"
                                                        placeholder="Search and select scheme"
                                                        optionFilterProp="children"
                                                        onBlur={() => {
                                                            setFieldTouched("scheme_code", true)
                                                        }}
                                                        onChange={(value) => {
                                                            this.handleAutoCompSelectChange(value, "scheme_code");
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.children.toString()
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        className={
                                                            (errors.scheme_code &&
                                                                touched.scheme_code
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        value={this.state.scheme_code || undefined}
                                                    >
                                                        {schemesDropDownListData &&
                                                            schemesDropDownListData.map((element, index) => (
                                                                <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                    {element.name} ({element.code})
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                    <ErrorMessage
                                                        name="scheme_code"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="scheme_plan_code">Medical Aid Plan{" "}<span className="mandatory">*</span></label>
                                                    <Select
                                                        showSearch={true}
                                                        showArrow={true}
                                                        allowClear={true}
                                                        name="scheme_plan_code"
                                                        disabled={!this.state.scheme_code}
                                                        placeholder="Search and select scheme plan"
                                                        optionFilterProp="children"
                                                        onBlur={() => {
                                                            setFieldTouched("scheme_plan_code", true)
                                                        }}
                                                        onChange={(value) => {
                                                            this.handleAutoCompSelectChange(value, "scheme_plan_code");
                                                        }}
                                                        filterOption={(input, option) =>
                                                            option.children.toString()
                                                                .toLowerCase()
                                                                .indexOf(input.toLowerCase()) >= 0
                                                        }
                                                        className={
                                                            (errors.scheme_plan_code &&
                                                                touched.scheme_plan_code
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                        value={this.state.scheme_plan_code || undefined}
                                                    >
                                                        {schemesPlanDropDownListData &&
                                                            schemesPlanDropDownListData.map((element, index) => (
                                                                <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                    {element.name} ({element.code})
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                    <ErrorMessage
                                                        name="scheme_plan_code"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>
                                                {mediaclAidSchemePlanOptions &&
                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                    mediaclAidSchemePlanOptionsOptions &&
                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                    (<div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                        <label htmlFor="scheme_plan_option_code">Medical Aid Plan Options{" "}
                                                            {/* <span className="mandatory">*</span> */}
                                                        </label>
                                                        <Select
                                                            showSearch={true}
                                                            showArrow={true}
                                                            allowClear={true}
                                                            disabled={!this.state.scheme_plan_code}
                                                            name="scheme_plan_option_code"
                                                            placeholder="Search and select scheme plan option"
                                                            optionFilterProp="children"
                                                            onBlur={() => {
                                                                setFieldTouched("scheme_plan_option_code", true)
                                                            }}
                                                            onChange={(value) => {
                                                                this.handleAutoCompSelectChange(value, "scheme_plan_option_code");
                                                            }}
                                                            filterOption={(input, option) =>
                                                                option.children.toString()
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            className={
                                                                (errors.scheme_plan_option_code &&
                                                                    touched.scheme_plan_option_code
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }
                                                            value={this.state.scheme_plan_option_code || undefined}
                                                        >
                                                            {schemesPlanOptionsDropDownListData &&
                                                                schemesPlanOptionsDropDownListData.map((element, index) => (
                                                                    <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                        {element.name} ({element.code})
                                                                    </Option>
                                                                ))}
                                                        </Select>
                                                        <ErrorMessage
                                                            name="scheme_plan_option_code"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </div>)}

                                                {mediaclAidSchemePlanOptions &&
                                                    mediaclAidSchemePlanOptions.length > 0 &&
                                                    mediaclAidSchemePlanOptionsOptions &&
                                                    mediaclAidSchemePlanOptionsOptions.length > 0 &&
                                                    mediaclAidSchemePlanSubOptionsOptions &&
                                                    mediaclAidSchemePlanSubOptionsOptions.length > 0 && (
                                                        <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                            <label htmlFor="scheme_plansuboption_code">Medical Aid Plan Sub Options{" "}
                                                                {/* <span className="mandatory">*</span> */}
                                                            </label>
                                                            <Select
                                                                showSearch={true}
                                                                showArrow={true}
                                                                allowClear={true}
                                                                disabled={!this.state.scheme_plan_option_code}
                                                                name="scheme_plansuboption_code"
                                                                placeholder="Search and select scheme plan suboption"
                                                                optionFilterProp="children"
                                                                onBlur={() => {
                                                                    setFieldTouched("scheme_plansuboption_code", true)
                                                                }}
                                                                onChange={(value) => {
                                                                    this.handleAutoCompSelectChange(value, "scheme_plansuboption_code");
                                                                    //this.handleChange(e);
                                                                }}
                                                                filterOption={(input, option) =>
                                                                    option.children.toString()
                                                                        .toLowerCase()
                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                className={
                                                                    (errors.scheme_plansuboption_code &&
                                                                        touched.scheme_plansuboption_code
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                value={this.state.scheme_plansuboption_code || undefined}
                                                            >
                                                                {schemesPlanSubOptionsDropDownListData &&
                                                                    schemesPlanSubOptionsDropDownListData.map((element, index) => (
                                                                        <Option key={index} title={`${element.name} (${element.code})`} value={element.code}>
                                                                            {element.name} ({element.code})
                                                                        </Option>
                                                                    ))}
                                                            </Select>
                                                            <ErrorMessage
                                                                name="scheme_plansuboption_code"
                                                                component="div"
                                                                className="invalid-feedback"
                                                            />
                                                        </div>)}

                                                <div className="col-md-6 col-lg-4 col-xl-3 mb-3">
                                                    <label htmlFor="membership_passport_number">
                                                        Member ID/Passport Number{" "}<span className="mandatory">*</span></label>
                                                    <Field
                                                        name="membership_passport_number"
                                                        maxLength="20"
                                                        placeholder="Member ID/Passport Number"
                                                        value={this.state.membership_passport_number}
                                                        onChange={this.handleChange}
                                                        className={
                                                            "form-control" +
                                                            (errors.membership_passport_number &&
                                                                touched.membership_passport_number
                                                                ? " is-invalid"
                                                                : "")
                                                        }
                                                    />
                                                    <ErrorMessage
                                                        name="membership_passport_number"
                                                        component="div"
                                                        className="invalid-feedback"
                                                    />
                                                </div>


                                                {/* <div className="col-md-6 col-lg-4 col-xl-3">
                                                    <div className="form-group">
                                                        <label htmlFor="dependent_code">Dependent Code
                                                <span className="mandatory">*</span>
                                                        </label>

                                                        <Field
                                                            name="dependent_code"
                                                            type="text"
                                                            maxLength="3"
                                                            placeholder="Dependent Code"
                                                            className={
                                                                "form-control" +
                                                                (errors.dependent_code && touched.dependent_code
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }
                                                            onChange={this.handleChange}
                                                        />
                                                        <ErrorMessage
                                                            name="dependent_code"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </div>
                                                </div> */}
                                            </div>
                                        )}

                                        <div className="row form-group">
                                            <div className="col-md-12 d-flex flex-wrap mb-3">
                                                <label htmlFor="communication" className="mr-3">
                                                    Preferred Method of Communication{" "}
                                                </label>
                                                <div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            type="radio"
                                                            className="custom-control-input"
                                                            id="sms"
                                                            name="communication"
                                                            checked={this.state.communication === "sms"}
                                                            onChange={this.handleChange}
                                                            value="sms"
                                                        />
                                                        <label className="custom-control-label" htmlFor="sms">
                                                            SMS
                                                        </label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            type="radio"
                                                            className="custom-control-input"
                                                            id="email"
                                                            name="communication"
                                                            checked={this.state.communication === "email"}
                                                            onChange={this.handleChange}
                                                            value="email"
                                                        />
                                                        <label className="custom-control-label" htmlFor="email">
                                                            Email
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/* <hr className={style.formBottomLine} /> */}


                                    <div className="form-box-shadow mb-4">
                                        {/* <div className="row">
                                            <div className="col-lg-12">
                                                <div className="mb-3">
                                                    <h4 className={style.proofHeading}>
                                                        Upload Documents
                                                         </h4>
                                                    <small>
                                                        {`You can upload maximum  ${this.state.max_upload} proof of payment and allowed extentions are .pdf, .jpg, .png, .svg.`}
                                                    </small>
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="row">
                                            <div className="col-lg-12">
                                                <PatientDocUpload
                                                    getUploadDocs={this.getUploadDocs}
                                                    state={this.state}
                                                />
                                            </div>
                                        </div>
                                    </div>



                                    {Object.keys(errors).length > 0 && (
                                            <div className="text-danger">
                                                Please fill all mandatory fields!
                                            </div>
                                        )}
                                    {this.state.isLoading && (
                                        <div className={`error ${style.loadingWrapper}`}>
                                            <img src={ttmLoader} alt="loader" className={style.loading} />
                                        </div>
                                    )}
                                    {!this.state.isLoading &&
                                        this.state.successMessage && (
                                            <div className="textCenter">
                                                <p className={`success-message`}>{this.state.successMessage}</p>
                                            </div>)}
                                    {!this.state.isLoading &&
                                        this.state.errorMessage && (<div className="textCenter">
                                            <p className={`error-message`}>{this.state.errorMessage}</p>
                                        </div>
                                        )}
                                    <div
                                        className={` d-flex
                                        justify-content-between
                                        flex-column-reverse
                                        flex-md-row
                                        align-items-center ${style.btnWrapper}`}
                                    >
                                        <button
                                            type="button"
                                            className="btn form-primary-btn mb-3"
                                            onClick={this.goBack}
                                        >
                                            Back
                                     </button>
                                        <button
                                            type="submit"
                                            className="btn form-primary-btn"
                                        >
                                            Submit
                                    </button>
                                    </div>
                                </div>
                            </Form>)}
                    </Formik>
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        dropdownListData: state.dropdownList,
        roomDropDownListData: state.roomDropDownList,
        savePatientData: state.savePatient,
        schemesData: state.schemes,
        schemesPlanData: state.schemesPlan,
        schemesPlanOptionsData: state.schemesPlanOptions,
        schemesPlanSubOptionsData: state.schemesPlanSubOptions,
        relatedPartyData: state.relatedPartyData,
        checkMSVDetailsData: state.checkMSVDetails
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchRelatedParty: (value) => dispatch(fetchRelatedParty(value)),
        checkMSVDetails: (payload) => dispatch(checkMSVDetails(payload)),
        savePatientProfile: (payload) => dispatch(savePatientProfile(payload)),
        fetchDropdownList: () => dispatch(fetchDropdownList()),
        fetchMedSchemes: (scheme) => dispatch(fetchMedSchemes(scheme)),
        fetchMedSchemesPlan: (scheme_code) => dispatch(fetchMedSchemesPlan(scheme_code)),
        fetchMedSchemesPlanOptions: (plan_code) => dispatch(fetchMedSchemesPlanOptions(plan_code)),
        fetchMedSchemesPlanSubOptions: (plan_option_code) => dispatch(fetchMedSchemesPlanSubOptions(plan_option_code)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPatient);
